var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBouncing3Dots = function SvgBouncing3Dots(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce0",
    attributeName: "cy",
    begin: "0;svgSpinners3DotsBounce1.end+0.25s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce1",
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBouncing3Dots);
export { ForwardRef as ReactComponent };